
export enum VTableHeaderType {
    Default,
    Status,
    Text,
    Number,
    Date,
    Vehicle,
    Checkbox
}
